/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';

import { CREATE_FRY7Q_USER_COMMENT, DELETE_FRY7Q_USER_COMMENT, UPDATE_FRY7Q_USER_COMMENT } from 'Apollo/Mutations/Rules/Fry7qResults';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_COMMENTS_FOR_FRY7Q } from 'Apollo/Queries/Rules/Fry7qResults';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';

import { tenantIdVar } from 'Apollo/config';
import FRY7QComment from '../components/FRY7QComment';

const FRY7QComments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [fry7qComment, setFRY7QComment] = useState('');
    const [fry7qShow, setFRY7QShow] = useState(false);
    const [fry7qTarget, setTarget] = useState(null);
    const [fry7qEdit, setEdit] = useState(false);
    const [fry7qSelectedComment, setFRY7QSelectedComment] = useState('');
    const [fry7qSelectedCommentID, setSelectedCommentID] = useState('');
    const [fry7qSelectedIndex, setSelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information  */
    const getFRY7QUser = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFRY7Q = {} } = {} }] = useLazyQuery(GET_COMMENTS_FOR_FRY7Q, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FRY7Q_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: fry7qComment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FRY7Q_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FRY7Q_USER_COMMENT);

    /* Comment option handler */
    const handleFRY7QClick = (index, text, commentId, event) => {
        setFRY7QShow(!fry7qShow);
        setSelectedIndex(index);
        setFRY7QSelectedComment(text);
        setSelectedCommentID(commentId);
        setTarget(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFRY7QComment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFRY7QComment('');
    };

    /* Toggled edit value */
    const onFRY7QEditClick = () => {
        setEdit(!fry7qEdit);
    };

    /* Cancal button handler */
    const onFRY7QCancelClick = () => {
        setEdit(!fry7qEdit);
        setSelectedIndex(null);
        setFRY7QSelectedComment('');
        setFRY7QShow(!fry7qShow);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFRY7QClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: fry7qSelectedComment,
                    commentId: fry7qSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setEdit(!fry7qEdit);
        setSelectedIndex(null);
        setFRY7QSelectedComment('');
        setFRY7QShow(!fry7qShow);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFRY7QClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: fry7qSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setSelectedIndex(null);
        setFRY7QSelectedComment('');
        setFRY7QShow(!fry7qShow);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <FRY7QComment
            getFRY7QUser={getFRY7QUser}
            fry7qComment={fry7qComment}
            setFRY7QComment={setFRY7QComment}
            commentLoading={commentLoading}
            addFRY7QComment={addFRY7QComment}
            loading={loading}
            getUserCommentsForFRY7Q={getUserCommentsForFRY7Q}
            handleFRY7QClick={handleFRY7QClick}
            onFRY7QEditClick={onFRY7QEditClick}
            onFRY7QClickDelete={onFRY7QClickDelete}
            onFRY7QCancelClick={onFRY7QCancelClick}
            onFRY7QClickSave={onFRY7QClickSave}
            fry7qShow={fry7qShow}
            fry7qTarget={fry7qTarget}
            fry7qEdit={fry7qEdit}
            fry7qSelectedComment={fry7qSelectedComment}
            fry7qSelectedCommentID={fry7qSelectedCommentID}
            setFRY7QSelectedComment={setFRY7QSelectedComment}
            fry7qSelectedIndex={fry7qSelectedIndex}
        />
    );
};

export default FRY7QComments;
